import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export default function NotFound() {
  return (
    <div className="container-x py-32 text-center" data-testid="not-found">
      <SEO title="Page not found" path="/404" noIndex />
      <p className="overline mb-4">404</p>
      <h1 className="font-display text-5xl font-semibold tracking-tight">
        We can't find that page.
      </h1>
      <Link to="/" className="btn-primary mt-8 inline-flex">
        Back home
      </Link>
    </div>
  );
}
